import React from 'react'
import Button from '#/components/Button'
import { comparePlan, Plan } from '#/consts/plan'
import cn from '#/utils/classnames'
import styles from '../styles.module.scss'

export interface PlanInfoProps {
  currentRole?: TopHap.UserRole
  currentPlan?: Plan
  period: 'monthly' | 'annual'
  plan: Plan & { customPrice?: number | string }
  onSelect(): void
  // onCancel?(): void
}

export default function PlanInfo({
  currentRole,
  currentPlan,
  period,
  plan,
  onSelect
}: // onCancel
PlanInfoProps) {
  let btnTitle = 'Try for Free'
  const authenticated = !!currentRole

  if (!authenticated) {
    btnTitle = 'Get Started'
  } else if (currentRole && currentRole !== 'free') {
    btnTitle = 'Upgrade'
  }

  const isSelected = currentPlan ?
    currentPlan.id === plan.id :
    plan.role === 'free' && currentRole
  const isLower = currentPlan && comparePlan(plan, currentPlan) < 0

  function renderActions() {
    if (plan.role === 'enterprise') {
      return (
        <Button className={styles['th-border-button']} onClick={onSelect}>
          Contact Us
        </Button>
      )
    }

    if (authenticated) {
      if (isSelected || plan.customPrice === 'WFG') {
        return (
          <div className={styles['th-current-label']} style={{ color: plan.color }}>
            Current Plan
          </div>
        )
      } else if (isLower) {
        return (
          <div className={styles['th-current-label']} style={{ color: plan.color }}>
            Included
          </div>
        )
      } else {
        return (
          <Button className={styles['th-border-button']} onClick={onSelect}>
            {btnTitle}
          </Button>
        )
      }
    } else {
      return (
        <Button className={styles['th-border-button']} onClick={onSelect}>
          {btnTitle}
        </Button>
      )
    }
  }

  function renderContent() {
    if (plan.role === 'free') {
      return <h5 className={styles['th-price']}>Free</h5>
    } else if (plan.role === 'enterprise') {
      return (
        <div className={cn('mx-2', styles['th-period'])}>
          Please contact us to discuss plan details that suits all your needs
        </div>
      )
    } else {
      if (plan.customPrice) {
        return (
          <div className={styles['th-price']}>
            {plan.customPrice}
          </div>
        )
      }
      return (
        <>
          <div className={styles['th-price']}>
            $
            {plan.monthlyPrice.toFixed(0)}
          </div>
          <div className={styles['th-price-unit']}>Per month</div>

          <div className={styles['th-period']}>
            Billed
            {' '}
            {period === 'monthly' ? 'monthly' : 'annually'}
          </div>
        </>
      )
    }
  }

  return (
    <div
      className={cn(styles['th-plan-info'], { [styles['th-recommended']]: plan.recommend })}
      style={plan.recommend ? { borderColor: plan.color } : {}}
    >
      <h5 className={styles['th-plan-role']} style={{ background: plan.color }}>
        {plan.name}
      </h5>
      <div className={styles['th-plan-content']}>
        <div className={styles['th-recommend']} style={{ color: plan.color }}>
          {plan.recommend ? 'Recommended' : ' '}
        </div>
        <div className={styles['th-price-info']} style={{ color: plan.color }}>
          {renderContent()}
        </div>
      </div>

      <div className={cn('pb-2', styles['th-action-wrapper'])}>{renderActions()}</div>
    </div>
  )
}
